export default __webpack_public_path__ + "static/media/Japan_Particle_0001_Aki_Claw.1a8b710d.png";